__webpack_require__.p = "https://gwc.staging.gopayapi.com/";